var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowReload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_14638",
    "data-name": "Group 14638",
    transform: "translate(-1723.076 -345.656)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_191",
    "data-name": "Ellipse 191",
    cx: 11,
    cy: 11,
    r: 11,
    transform: "translate(1723.076 345.656)",
    fill: "#394f65"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7803",
    "data-name": "Path 7803",
    d: "M183.846,25.075c-.033-.193-.061-.354-.089-.517a.612.612,0,0,1,.5-.736.6.6,0,0,1,.692.518q.185,1.032.358,2.067a.606.606,0,0,1-.522.73l-2.069.354A.605.605,0,0,1,182,27a.6.6,0,0,1,.478-.694c.253-.053.508-.091.763-.136l.014-.049c-.3-.115-.586-.256-.89-.34A3.932,3.932,0,1,0,185.22,30.2a.6.6,0,0,1,.691-.55.607.607,0,0,1,.5.755,5.153,5.153,0,0,1-5.295,4.3,5.143,5.143,0,0,1-1.106-10.11,5.058,5.058,0,0,1,3.691.4Z",
    transform: "translate(1552.838 327.031)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowReload);
export default __webpack_public_path__ + "static/media/arrow-reload.347f5d0e6b14729dfbdd25fa0aec20fb.svg";
export { ForwardRef as ReactComponent };